'use client'

import dynamic from 'next/dynamic'

import { HeroBackground, Spotlight } from 'design-studio'

const ThreeHero = dynamic(
  () =>
    import('@/components/three-hero').then((mod) => ({
      default: mod.ThreeHero,
    })),
  { ssr: false },
)

export function HomeBackground({ mountCanvas }: { mountCanvas: boolean }) {
  return (
    <HeroBackground>
      <div className="fixed z-[-1] h-full w-full bg-[#161125]" />
      {mountCanvas && <ThreeHero />}
      <Spotlight
        color="from-teal-600/20"
        className="fixed -right-200 -bottom-250 z-0 size-512"
      />
    </HeroBackground>
  )
}
